import getCurrencySymbol from './getCurrencySymbol';

const forceLocale = (num, places) =>
    new Number(num).toLocaleString(
        {},
        { minimumFractionDigits: places, maximumFractionDigits: places },
    );

const currencyFormat = (
    value,
    decimalPlaces = 0,
    currency = 'USD',
    shouldDisplayPositiveSign = false,
) => {
    const symbol = getCurrencySymbol(currency);
    const localValue = forceLocale(value, decimalPlaces);
    const positiveSign = value > 0 && shouldDisplayPositiveSign ? '+' : '';
    return `${symbol}${positiveSign}${localValue}`;
};

export default currencyFormat;
